(() => {
  const closeMobileMenus = () => {
    document.querySelectorAll('.gg-mobile-menu[open]').forEach((menu) => menu.removeAttribute('open'));
    document.body.classList.remove('glycgo-menu-open');
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.gg-mobile-menu').forEach((menu) => {
      menu.addEventListener('toggle', () => {
        document.body.classList.toggle('glycgo-menu-open', menu.open);
      });

      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMobileMenus));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMobileMenus();
    });

    const header = document.querySelector('.gg-site-header');
    if (header) {
      const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });
    }

    document.querySelectorAll('[data-gg-sticky-atc]').forEach((button) => {
      button.addEventListener('click', () => {
        const productInfo = document.querySelector(button.dataset.ggStickyAtc);
        const submit = productInfo?.querySelector('.product-form__submit');
        if (submit && !submit.disabled) {
          submit.click();
        } else {
          productInfo?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  });
})();
